<template>
  <v-container>
    <base-material-card
      id="mechanical-condition-chart"
      color="primary"
      icon="mdi-chart-bell-curve-cumulative"
      :title="$t('dashboard.mechanincalConditionOverTime')"
      class="px-4 py-3 mt-12"
    >
      <apexchart
        v-if="isThereDataToShow"
        type="line"
        :options="options"
        :series="inspecciones"
      ></apexchart>
      <div v-else class="optional">
        <v-card class="pa-10" color="secondary" dark>
          Not enough operational information (inspections) yet
        </v-card>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
export default {
  async created() {
    this.$store.dispatch(
      "inspections/bindInspectionsOfEquipment",
      this.$route.params.id
    );
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("inspections", ["inspections"]),
    ...mapGetters("auth", ["isMetric", "isMetax", "adminAndUp"]),
    options() {
      return {
        chart: {
          background: this.$vuetify.theme.dark ? "#1E1E1E" : "#FFFFFF",
          id: "MechanicalHealthCondition"
        },
        stroke: {
          curve: "stepline"
        },

        xaxis: {
          type: "datetime",
          labels: {
            format: "dd/MM/yyyy"
          }
        },
        yaxis: {
          min: 0,
          max: 3,
          tickAmount: 3,
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label"
            },
            offsetX: 0,
            offsetY: 0,
            rotate: 0,
            formatter: value => {
              switch (value) {
                case 1:
                  return this.$t("inspectionProfile.smoothZone");
                case 2:
                  return this.$t("inspectionProfile.warningZone");
                case 3:
                  return this.$t("inspectionProfile.alarmZone");

                default:
                  return "N/A";
              }
            }
          }
        },
        theme: {
          mode: this.$vuetify.theme.dark ? "dark" : "light",
          monochrome: {
            enabled: true,
            color: "#255aee",
            shadeTo: "light",
            shadeIntensity: 0.65
          }
        },
        noData: {
          text: "There is no data for this API",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "14px",
            fontFamily: undefined
          }
        }
      };
    },
    inspecciones() {
      let data = _.chain(this.inspections)
        .sortBy(e => e.dateCreated.seconds * 1000)
        .map(e => [
          new Date(e.dateCreated.seconds * 1000),
          e.resume?.status?.value
        ])
        .value();

      return [{ name: "Mechanincal Condition ", data: data }];
    },
    isThereDataToShow() {
      return this.inspections[0]?.data ? true : false;
    },
    grupos() {
      let data = _.chain(this.inspecciones)
        .groupBy("code")
        .map((value, key) => ({ name: key, value: value }))
        .value();

      return data;
    }
  }
};
</script>
